import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

interface AuthRedirectProps {
  children: React.ReactNode
}

export function AuthRedirect({ children }: AuthRedirectProps) {
  const { user, userType, loading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [forceRender, setForceRender] = useState(false)

  // Timeout para evitar loading infinito
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (loading) {
        console.warn('Auth loading timeout - forcing render')
        setForceRender(true)
      }
    }, 5000) // 5 segundos de timeout

    return () => clearTimeout(timeout)
  }, [loading])

  useEffect(() => {
    // Só redirecionar se não estiver carregando e o usuário estiver logado
    if (!loading && user && userType) {
      const currentPath = location.pathname
      
      // Páginas que não precisam de redirecionamento
      const publicPages = [
        '/',
        '/models',
        '/profile',
        '/tokens',
        '/terms',
        '/privacy',
        '/help',
        '/contact',
        '/login',
        '/register',
        '/welcome'
      ]
      if (publicPages.includes(currentPath) || currentPath.startsWith("/profile/")) {
        return
      }
      
      // Se é modelo e não está na dashboard, redirecionar
      if (userType === 'model' && currentPath !== '/model-dashboard') {
        console.log('Redirecionando modelo para dashboard')
        navigate('/model-dashboard', { replace: true })
      }
      // Se é cliente e está na dashboard da modelo, redirecionar para home
      else if (userType === 'client' && currentPath === '/model-dashboard') {
        console.log('Redirecionando cliente para home')
        navigate('/', { replace: true })
      }
    }
  }, [user, userType, loading, navigate, location.pathname])

  // Mostrar loading enquanto verifica autenticaÃ§Ã£o (com timeout)
  if (loading && !forceRender) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500"></div>
      </div>
    )
  }

  return <>{children}</>
}




